import { render, staticRenderFns } from "./bottomContMobile.vue?vue&type=template&id=44c54166&scoped=true"
import script from "./bottomContMobile.vue?vue&type=script&lang=js"
export * from "./bottomContMobile.vue?vue&type=script&lang=js"
import style0 from "./bottomContMobile.vue?vue&type=style&index=0&id=44c54166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c54166",
  null
  
)

export default component.exports